import React, { useState, useEffect } from "react";
import { useAuth } from '../../context/AuthContext';
import axios from "axios";
import Swal from 'sweetalert2';
import { EXPRESS_BASE_URL } from "../../Helpers/apiConfig";

export const UserMessage = () => {
    const { user } = useAuth();

    // AuthContext'ten gelen kullanıcının kendi ID'si
    const currentUserId = user.user.id || user.nameid;

    // Liste ve Modal Stateleri
    const [messages, setMessages] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [loading, setLoading] = useState(true);

    const [showModal, setShowModal] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState(null);

    // Node.js API adresiniz
    const API_URL = EXPRESS_BASE_URL + "/api/messages";

    // GELEN KUTUSUNU VE OKUNMAMIŞ SAYISINI ÇEKME
    const fetchMessagesData = async () => {
        if (!currentUserId) return;
        setLoading(true);
        try {
            const listRes = await axios.get(`${API_URL}/list/${currentUserId}`);
            console.log("Mesaj Listesi:", listRes.data);
            if (listRes.data.success) {
                setMessages(listRes.data.data);
            }

            const countRes = await axios.get(`${API_URL}/unread-count/${currentUserId}`);
            if (countRes.data.success) {
                setUnreadCount(countRes.data.count);
            }
        } catch (error) {
            console.error("Yükleme hatası:", error);
            // Kullanıcıyı rahatsız etmemek için burada Swal yerine sadece console.error kullanıyoruz
        }
        setLoading(false);
    };

    // MESAJ DETAYINI AÇMA VE OKUNDU İŞARETLEME
    const handleReadMessage = async (id) => {
        try {
            Swal.fire({
                title: 'Yükleniyor...',
                allowOutsideClick: false,
                didOpen: () => { Swal.showLoading() }
            });

            const res = await axios.get(`${API_URL}/detail/${id}/${currentUserId}`);

            if (res.data.success) {
                Swal.close(); // Yükleniyor popup'ını kapat
                setSelectedMessage(res.data.data);
                setShowModal(true);

                // Eğer mesaj yeni okunuyorsa, UI tarafındaki sayıyı hemen güncelle
                if (!res.data.data.is_read) {
                    fetchMessagesData();
                }
            }
        } catch (error) {
            Swal.fire("Hata", "Mesaj detayı alınamadı.", "error");
        }
    };

    useEffect(() => {
        fetchMessagesData();
    }, [currentUserId]);

    return (
        <div style={{ position: "relative", padding: "20px" }}>
            <div style={{ textAlign: "center", marginBottom: "30px" }}>
                <h1>Duyurular ve Mesajlar</h1>
            </div>

            {/* Gelen Kutusu Listesi */}
            <div className="card shadow-sm p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="m-0">Gelen Kutusu</h3>
                    {unreadCount > 0 && (
                        <span className="badge bg-danger fs-6 px-3 py-2 rounded-pill shadow-sm">
                            {unreadCount} Yeni Mesaj
                        </span>
                    )}
                </div>

                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Yükleniyor...</span>
                        </div>
                        <p className="mt-2 text-muted">Mesajlarınız yükleniyor...</p>
                    </div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-hover align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th style={{ width: "10%" }} className="text-center">Durum</th>
                                    <th style={{ width: "50%" }}>Konu / Başlık</th>
                                    <th style={{ width: "25%" }}>Tarih</th>
                                    <th style={{ width: "15%" }} className="text-center">İşlem</th>
                                </tr>
                            </thead>
                            <tbody>
                                {messages.length > 0 ? messages.map(item => (
                                    <tr
                                        key={item.id}
                                        style={{
                                            backgroundColor: item.is_read ? 'transparent' : '#f8f9fa',
                                            fontWeight: item.is_read ? 'normal' : '600'
                                        }}
                                    >
                                        <td className="text-center">
                                            {item.is_read ? (
                                                <i className="fas fa-envelope-open text-secondary" title="Okundu"></i>
                                            ) : (
                                                <i className="fas fa-envelope text-primary" title="Yeni Mesaj"></i>
                                            )}
                                        </td>
                                        <td>{item.title}</td>
                                        <td className="text-muted small">
                                            {new Date(item.created_at).toLocaleString("tr-TR", {
                                                day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit'
                                            })}
                                        </td>
                                        <td className="text-center">
                                            <button
                                                className={`btn btn-sm ${item.is_read ? 'btn-outline-secondary' : 'btn-primary'}`}
                                                onClick={() => handleReadMessage(item.id)}
                                            >
                                                {item.is_read ? 'Tekrar Oku' : 'Mesajı Oku'}
                                            </button>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="4" className="text-center py-5 text-muted">
                                            <i className="fas fa-inbox fa-3x mb-3 text-light"></i>
                                            <h5>Gelen kutunuz boş</h5>
                                            <p>Şu an için size gönderilmiş bir mesaj bulunmuyor.</p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Mesaj Detay Modalı */}
            {showModal && selectedMessage && (
                <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1050, display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className="card p-0 shadow-lg" style={{ position: "relative", width: "650px", maxWidth: "95%", maxHeight: "90vh", overflowY: "auto", backgroundColor: "#fff", borderRadius: "10px" }}>

                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Kapat"
                            onClick={() => setShowModal(false)}
                            style={{ position: "absolute", top: "15px", right: "15px", zIndex: 1 }}
                        ></button>

                        {selectedMessage.cover_image && (
                            <img src={selectedMessage.cover_image} alt="Kapak" style={{ width: "100%", maxHeight: "300px", objectFit: "cover", borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }} />
                        )}

                        <div className="card-body p-4 p-md-5">
                            <h2 className="card-title mb-2 fw-bold text-dark">{selectedMessage.title}</h2>
                            <p className="text-muted mb-4 small">
                                <i className="far fa-clock me-1"></i>
                                {new Date(selectedMessage.created_at).toLocaleString("tr-TR", {
                                    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'
                                })}
                            </p>

                            <hr className="mb-4" />

                            <div
                                className="message-content text-dark"
                                style={{ lineHeight: "1.6", fontSize: "1.05rem" }}
                                dangerouslySetInnerHTML={{ __html: selectedMessage.content }}
                            />

                            <div className="d-flex justify-content-end border-top pt-4 mt-5">
                                <button className="btn btn-secondary px-4 py-2" onClick={() => setShowModal(false)}>Kapat</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserMessage;